/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

export const TwentyIcTable = ({ className, color = "white" }) => {
  return (
    <svg
      className={`twenty-ic-table ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="rect"
        height="10"
        stroke={color}
        strokeLinejoin="round"
        strokeWidth="2"
        width="16"
        x="2"
        y="5"
      />
      <path
        className="path"
        d="M4.5 2H8"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        className="path"
        d="M4.5 18H8"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        className="path"
        d="M12 2H15.5"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        className="path"
        d="M12 18H15.5"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
};
